import React from 'react';
import { Box, Flex, Text, IconButton, Center } from '@chakra-ui/react';
import { arrayOf, bool, object, number } from 'prop-types';
import { AiFillPushpin, AiOutlineArrowDown } from 'react-icons/ai';
import dayjs from 'dayjs';
import 'dayjs/locale/id';
import 'dayjs/locale/en';

import { DEFAULT_LANGUAGE } from '@/constants/feature-flags';

function WishlistItem({ item, index }) {
  return (
    <Box key={`wishlist-${index}`}>
      <Flex alignItems="top" marginTop="16px" boxShadow="sm">
        <Box width="100%">
          <Box
            padding="4px 8px"
            borderTopLeftRadius="6px"
            borderTopRightRadius="6px"
            bgColor="bgAlternative"
            width="100%"
          >
            <Flex alignItems="center">
              <Text
                color="alternativeColorText"
                marginRight="8px"
                fontWeight="bold"
                fontSize="sm"
                fontFamily="body"
              >
                {item.name}
              </Text>
              {item.isPinByAdmin === 1 && <AiFillPushpin color="white" />}
            </Flex>
          </Box>
          <Box
            marginTop="2px"
            padding="4px 8px"
            bgColor="bgAlternative"
            width="100%"
            fontFamily="body"
            color="alternativeColorText"
            textAlign="left"
            borderBottomLeftRadius="6px"
            borderBottomRightRadius="6px"
          >
            <Text fontSize="sm">{item.wish}</Text>
            <Text
              fontSize="xs"
              color="alternativeColorText"
              fontFamily="body"
              marginTop="4px"
              marginLeft="4px"
            >
              {dayjs(item.time).locale(DEFAULT_LANGUAGE).format('DD MMMM YYYY')} |{' '}
              {dayjs(item.time).locale(DEFAULT_LANGUAGE).format('hh:mm A')}
            </Text>
          </Box>
        </Box>
      </Flex>
    </Box>
  );
}

WishlistItem.propTypes = {
  item: object.isRequired,
  index: number.isRequired,
};
/**
 * @function WishlistCard
 * @description a functional component for wishlist card
 */
function WishlistCard({ wishlistData, loading }) {
  const renderWishlist = () => {
    let finalResult = [];
    let wishlist = [];
    let pinnedWishlist = [];

    wishlistData.forEach((item, index) => {
      if (item.isPinByAdmin === 1) {
        pinnedWishlist.push(<WishlistItem key={index} item={item} index={index} />);
      } else {
        wishlist.push(<WishlistItem key={index} item={item} index={index} />);
      }
    });

    wishlist = wishlist.reverse();
    finalResult = [...pinnedWishlist, wishlist];

    return finalResult;
  };

  const getHeight = React.useMemo(() => {
    if (wishlistData.length === 0) return '0';
    if (wishlistData.length === 1) return '200px';
    return '300px';
  }, [wishlistData.length]);

  return (
    <Box id="wishlist__box">
      <Box height={getHeight} overflow="scroll" margin="16px 0">
        <Box paddingBottom="36px">{!loading && renderWishlist()}</Box>
      </Box>
      {wishlistData.length > 2 && (
        <Box width="100%" marginTop="-32px">
          <Center>
            <IconButton
              boxShadow="xl"
              size="sm"
              icon={<AiOutlineArrowDown />}
              isRound
              className="animation-heart button__arrowdown"
            />
          </Center>
        </Box>
      )}
    </Box>
  );
}

WishlistCard.propTypes = {
  loading: bool,
  wishlistData: arrayOf(object),
};

WishlistCard.defaultProps = {
  loading: false,
  wishlistData: [],
};

export default WishlistCard;
